import { useMutation } from "@tanstack/react-query";
import { LegalPageKey, LegalPageLanguageType } from "../../models/LegalPage";
import { LegalPageService } from "../../services/legal-page.service";

export const useLegalPageMutations = () => {
  const { mutate: saveLegalPage, isPending: isSaving } = useMutation<
    any,
    Error,
    { key: LegalPageKey; language: LegalPageLanguageType; content: string }
  >({
    mutationFn: async ({ key, language, content }) => LegalPageService.save(key, language, content),
  });

  return { saveLegalPage, isSaving };
};
